module.exports = __webpack_public_path__ + "img/Asset 5.3a5c11b7.png";